window.Drupal.behaviors.closings = {
  attach() {
    ;[...document.querySelectorAll('.closings')].forEach((el) => {
      if (el.classList.contains('is-collapsed')) {
        const btn = el.querySelector('.separator__btn')
        if (btn) {
          btn.addEventListener('click', () => {
            el.classList.remove('is-collapsed')
          })
        }
      }
    })
  },

  detach() {}
}
